import { render, staticRenderFns } from "./LimitList.vue?vue&type=template&id=2921a16e&scoped=true"
import script from "./LimitList.vue?vue&type=script&lang=js"
export * from "./LimitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921a16e",
  null
  
)

export default component.exports